export function handlerUseStateVmodel (mergeOldWithNew = false) {
  // General mixin that decides from a prop if use the useState prop or
  // the giver v-model.
  // If you want to set the state you can use this.state = obj that
  // this mixin will guess by the given props if should use the v-model or commit to vuex
  // You can use the callback too, it should receive a computed object like, eg: {set: func, get: func}
  // it is usefull when you need to dynamic generate a generic computed, you can se in use at calcDedailsRules
  return {
    props: {
      useState: {required: false},
      value: {'default': undefined},
      customVmodel: {'default': undefined}
    },
    computed: {
      state: {
        get () {
          if (this.value === undefined && !this.useState && !this.$listeners.change && !this.customVmodel) {
            throw new Error('Missing required params, this component need useState, v-model (should not be undefined), @change or customVmodel')
          }

          if (this.customVmodel) {
            return this.customVmodel.get()
          } else if (this.value === undefined) {
            return this.$getterUseState(this.useState)
          } else {
            return this.value
          }
        },
        set (value) {
          if (this.customVmodel) {
            this.customVmodel.set(value)
          } else if (this.value === undefined) {
            this.$store.commit(this.useState, value)
          } else {
            const final = mergeOldWithNew ? {...this.state, ...value} : value

            this.$emit('input', final)
            if (this.$listeners.change) {
              this.$emit('change', final)
            }
          }
        }
      }
    },
    methods: {
      _setState (newState) {
        this.state = {...newState}
      }
    }
  }
}

export function elementFocusable (refElementToFocus = 'defaultFocus') {
  // Use this mixin to create a method in the component called focus
  // that already find the element in $refs that must be focused
  // to it works you need a element in component with the ref as the param to this mixin
  return {
    methods: {
      focus () {
        if (this.$refs[refElementToFocus]) {
          this.$refs[refElementToFocus].focus()
        }
      }
    }
  }
}

/**
 * Está função retorna um mixin para um componente Vue que dada uma prop `chave` irá ler/escrever um boleano nessa chave.
 * O valor da chave será setado atribuindo um novo valor ao `memorizador`.
 * @returns Um mixin pra ser utilizado em um componente que salva e resgata itens do LocalStorage
 * 
 */
export function memorizadorLocal () {
  return {
    props: {
      chave: {
        type: String,
        required: false,
        default: 'memoria'
      },

      storage: {
        type: String,
        required: false,
        default: 'memorizadorLocal'
      }
    },
  
    computed: {
      memorizadorLocal () {
        const {storage} = this
        const memorizadorLocal = localStorage.getItem(storage)
        if (memorizadorLocal) {
          return JSON.parse(memorizadorLocal)
        }
        return {}
      },
  
      memorizador: {
        get () {
          const {memorizadorLocal, chave} = this
          return memorizadorLocal && memorizadorLocal[chave] === true
        },
  
        set (novoValor) {
          const {memorizadorLocal, chave, storage} = this
          const novoPreventivo = {
            ...memorizadorLocal,
            [chave]: !!novoValor
          }
          const novoPreventivoEmString = JSON.stringify(novoPreventivo)
          localStorage.setItem(storage, novoPreventivoEmString)
        }
      }
    }
  }
}